import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=6b2a170a&"
import script from "./NavigationItem.vue?vue&type=script&lang=js&"
export * from "./NavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2a170a')) {
      api.createRecord('6b2a170a', component.options)
    } else {
      api.reload('6b2a170a', component.options)
    }
    module.hot.accept("./NavigationItem.vue?vue&type=template&id=6b2a170a&", function () {
      api.rerender('6b2a170a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/responsive/NavigationItem.vue"
export default component.exports